import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "nl",
  pure: true,
})
export class NlPipe implements PipeTransform {
  public transform(value: Array<{ language: string; translation: string }>) {
    return value.find((translation) => translation.language === "nl_NL")
      .translation;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/nl/nl.ts